import { useAppSelector } from "@/app/hooks";
import { selectCurrentLeaseComp } from "@/features/survey/leaseCompsSelectors";
import type { LeaseComp } from "@/features/survey/types/survey.leaseComp.types";

export const useCurrentLeaseComp = (): LeaseComp | null => {
  return useAppSelector(selectCurrentLeaseComp);
};
